import i18n from '@/i18n';

export default {
  computed: {
    statusItems() {
      return [
        {
          text: i18n.t('global.filter.statuses.all'),
          value: null,
        },
        {
          text: i18n.t('global.filter.statuses.active'),
          value: 1,
        },
        {
          text: i18n.t('global.filter.statuses.inactive'),
          value: 0,
        },
      ];
    },
  },
};

